import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Textarea,
  Text,
  Box,
} from "@chakra-ui/react";
import PrimaryButton from "../../../components/PrimaryButton";
import PrimarySideHeader from "../../../components/PrimarySideHeader";

const RejectOpinion = ({
  isOpen,
  onClose,
  onSubmit,
  rejectionOpinion,
  setRejectionOpinion,
  doctorOpinionData,
  isFromMedicalOpinion = false,
  setMedicalOpinionRejectedButton,
}) => {
  const handleReasonChange = (e) => {
    setRejectionOpinion(e.target.value);
  };

  const handleSubmit = () => {
    if (rejectionOpinion.trim() === "") {
      alert("Rejection reason is required.");
      return;
    }
    onSubmit(rejectionOpinion);
    setMedicalOpinionRejectedButton(false);
    onClose();
  };

  const handleClose = () => {
    setMedicalOpinionRejectedButton(false);
    onClose();
  };

  const renderDoctorOpinion = () => {
    if (!doctorOpinionData) return null;
    switch (doctorOpinionData.mime_type) {
      case "Text":
        return (
          <>
            <PrimarySideHeader mb={2}>
              Doctor's Rejection Opinion:
            </PrimarySideHeader>
            <Box mb={4} p={3} bg="gray.50" borderRadius="md">
              <Text>{doctorOpinionData.opinion[0]}</Text>
            </Box>
          </>
        );
      case "Image":
        return (
          <>
            <PrimarySideHeader mb={2}>
              Doctor's Rejection Opinion:
            </PrimarySideHeader>
            <Box mb={4} bg="gray.50" p={3} borderRadius="md">
              {doctorOpinionData.opinion.map((opinion, index) => (
                <Box display="flex" alignItems="center" key={index} mb={2}>
                  <Text flex="1" noOfLines={1}>
                    {opinion.split("/").pop()}
                  </Text>
                  <Button
                    size="sm"
                    colorScheme="blue"
                    onClick={() => window.open(opinion, "_blank")}
                    ml={2}
                  >
                    View
                  </Button>
                </Box>
              ))}
            </Box>
          </>
        );
      case "Audio":
        return (
          <>
            <PrimarySideHeader mb={2}>
              Doctor's Rejection Opinion:
            </PrimarySideHeader>
            <Box mb={4} bg="gray.50" p={3} borderRadius="md">
              {doctorOpinionData.opinion.map((opinion, index) => (
                <Box display="flex" alignItems="center" key={index} mb={2}>
                  <Text flex="1" noOfLines={1}>
                    {opinion.split("/").pop()}
                  </Text>
                  <Button
                    size="sm"
                    colorScheme="blue"
                    onClick={() => window.open(opinion, "_blank")}
                    ml={2}
                  >
                    View
                  </Button>
                </Box>
              ))}
            </Box>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered size="2xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="primary.1" textAlign={"center"} fontSize={"2xl"}>
          Reject Opinion
        </ModalHeader>
        <ModalBody>
          {isFromMedicalOpinion && renderDoctorOpinion()}
          <Text mb={4} fontWeight={"bold"}>
            Please provide a reason for rejecting the opinion:
          </Text>
          <Textarea
            value={rejectionOpinion}
            onChange={handleReasonChange}
            placeholder="Enter your reason here..."
            size="sm"
          />
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="red" mr={3} onClick={handleClose}>
            Cancel
          </Button>
          <PrimaryButton onClick={handleSubmit}>Submit</PrimaryButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RejectOpinion;
